// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3KAFy","dragIcon":"SortableItem_dragIcon__2ZliE","disabled":"SortableItem_disabled__WBJhU"};